import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const tableData = [{
  material: "true phenolic",
  bestFor: "Control panels, MIL-SPEC work, dielectric applications",
  typicalUse: "Legend plates, nameplates, defense/marine"
}, {
  material: "Two-color acrylic",
  bestFor: "Fast lead time, indoor/outdoor, wide color range",
  typicalUse: "Legend plates, equipment ID, signage"
}, {
  material: "Stainless steel (304/316)",
  bestFor: "Harsh, high-temp, wash-down environments",
  typicalUse: "Valve tags, equipment nameplates, asset tags"
}, {
  material: "Anodized aluminum",
  bestFor: "Outdoor, UV exposure, lightweight installs",
  typicalUse: "Nameplates, panel ID, data plates"
}, {
  material: "Brass",
  bestFor: "Process identification, decorative durability",
  typicalUse: "Valve tags, legacy facility tags"
}];
export default function MaterialBreadthTable() {
  return <section id="material-breadth-table" className="bg-foreground text-secondary py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="mb-12 max-w-4xl">
          <h2 className="font-default text-3xl md:text-4xl font-bold mb-6 text-secondary">
            Which Material Fits Your Application?
          </h2>
          <p className="text-lg md:text-xl leading-relaxed text-secondary/90 font-sans">
            There are five material families Evermark Industrial Solutions
            engraves: true phenolic, two-color acrylic, stainless steel,
            anodized aluminum, and brass. The right one depends on the
            environment, the code, and the install method — and Evermark
            recommends confirming safety-critical specifications with a
            qualified specialist.
          </p>
        </div>

        <div className="bg-background/5 rounded-lg border border-secondary/20 overflow-hidden mb-10 shadow-sm">
          <Table>
            <TableHeader>
              <TableRow className="border-secondary/20 hover:bg-transparent">
                <TableHead className="text-secondary font-bold text-base py-4 w-[25%]">
                  Material
                </TableHead>
                <TableHead className="text-secondary font-bold text-base py-4 w-[40%]">
                  Best For
                </TableHead>
                <TableHead className="text-secondary font-bold text-base py-4 w-[35%]">
                  Typical Use
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {tableData.map((row, i) => <TableRow key={i} data-index={i} className="border-secondary/20 hover:bg-secondary/5 transition-colors">
                  <TableCell className="font-semibold text-secondary py-4 align-top">
                    {row.material}
                  </TableCell>
                  <TableCell className="text-secondary/90 py-4 align-top">
                    {row.bestFor}
                  </TableCell>
                  <TableCell className="text-secondary/90 py-4 align-top">
                    {row.typicalUse}
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>

        <div className="flex justify-center">
          <Button asChild variant="link" className="text-primary hover:text-primary/80 text-lg font-semibold h-auto p-0">
            
          </Button>
        </div>
      </div>
    </section>;
}